import { useEffect, useState } from "react";

interface LoadingSpinnerProps {
  size?: number; // Optional size prop in pixels
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 24,
  className = "",
}) => {
  const [currentFrame, setCurrentFrame] = useState(0);

  // Correct paths assuming 'public' is the web root
  const frames = [
    "/loading/1.svg",
    "/loading/2.svg",
    "/loading/3.svg",
    "/loading/4.svg",
    "/loading/5.svg",
    "/loading/6.svg",
    "/loading/7.svg",
    "/loading/8.svg",
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentFrame((prev) => (prev + 1) % frames.length);
    }, 75); // Adjust timing as needed (75ms = about 13fps)

    return () => clearInterval(intervalId);
  }, []); // frames is static; safe to run once

  return (
    <img
      src={frames[currentFrame]}
      alt="Loading..."
      style={{
        width: size,
        height: size,
      }}
      className={className}
      loading="eager" // Prioritize loading spinner images
    />
  );
};

export default LoadingSpinner;
